import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { IonicModule, ModalController, NavController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import { TranslatePipe } from '@ngx-translate/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { selectClubOverview } from '../../state/club/club.selector';
import { Club } from '../../model';
import { defaultBadgeUrl } from '../../util/challenge.util';
import { HeaderComponent } from '@fitup-monorepo/components/lib/header/header.component';
import { ClubCardComponent } from '@fitup-monorepo/challenge/lib/components/club-card/club-card.component';
import { AppRoutes } from '@fitup-monorepo/routes/lib/app-routes';

@Component({
  selector: 'app-club-picker-modal',
  templateUrl: './club-picker-modal.component.html',
  styleUrls: ['./club-picker-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IonicModule, TranslatePipe, HeaderComponent, ClubCardComponent],
})
export class ClubPickerModalComponent {
  private readonly store = inject(Store);
  private readonly modalController = inject(ModalController);
  private readonly navController = inject(NavController);

  protected readonly groupOverview = toSignal(this.store.select(selectClubOverview));
  protected readonly defaultBadgeUrl = defaultBadgeUrl;

  public static async openModal(modalController: ModalController): Promise<Club | null> {
    const modal = await modalController.create({
      component: ClubPickerModalComponent,
      id: 'group-picker-modal',
      cssClass: ['fu-modal-default'],
    });
    await modal.present();
    const result = await modal.onDidDismiss<Club | null>();
    return result.data ?? null;
  }

  protected async selectClub(group: Club): Promise<void> {
    await this.modalController.dismiss(group, 'selected', 'group-picker-modal');
  }

  protected async navigateToClubs(): Promise<void> {
    await this.modalController.dismiss(null, null, 'group-picker-modal');
    await this.navController.navigateForward([AppRoutes.TABS_CHALLENGES], { queryParams: { tab: 'group' } });
  }

  protected async closeModal(): Promise<void> {
    await this.modalController.dismiss(null, null, 'group-picker-modal');
  }
}
